import axios from '../http'

function query(data) {
    return axios.post('/event/teamEntry/query', data);
}


function add(data) {
    return axios.post('/event/teamEntry/add', data);
}

function update(data) {
    return axios.post('/event/teamEntry/update', data);
}

function get(id) {
    return axios.get('/event/teamEntry/get?id=' + id);
}

function del(data) {
    return axios.post('/event/teamEntry/del', data);
}

function approve(data) {
    return axios.post('/event/teamEntry/approve', data);
}

function importExcel(file){
    let formData = new FormData();
    formData.append("file", file);
    return axios.post("/event/teamEntry/importExcel", formData, {headers: {"Content-type": "multipart/form-data"}});
    
}


function exportExcel(data){
    const url =  "/event/teamEntry/exportExcel";
    return axios.post(url, data, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Entries by Team.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

function print(id) {
    const url = "/event/teamEntry/print?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}


export default {
    query,
    get,
    add,
    update,
    del,
    importExcel,
    exportExcel,
    print,
    approve
}